<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
      <div class="d-grid grid-columns-top-3">
        <div class="accounts">
          <ul>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="search">
          <form action="search-results.html" method="get">
            <input id="search" name="search" type="text" [(ngModel)]="clasCCode" (keyup) = "retriveDoctorsLookup()"
              placeholder="Doctor Code">
            <label>                      </label>
            <input id="search" name="search" type="text" [(ngModel)]="clasCName" (keyup)="retriveDoctorsLookup()"
              placeholder="Doctor Name">

          </form>
        </div>
      </div>
    </div>
  </section>

  <table>
    <thead>
      <tr>
        <th style="width: 30%;">Class Code</th>
        <th style="width: 100%;">Class Name</th>
        <th style="width: 20%;">Choose</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Do of ContClassList; let i = index">
        <td data-column="Doctor ID">{{Do.clasCCode}}</td>
        <td data-column="Doctor Name">{{Do.clasCName}}</td>

        <td data-column="Choose"><button type="button" class="theme-button btn" id="select" name="select"
            (click)="SelectContClass(Do)">Select</button>
        </td>
      </tr>

    </tbody>
  </table>
</mat-dialog-content>

